import { gql } from "urql";
export const CreatePriorityStatusMutation = gql `
    mutation CreatePriorityStatus(
        $name: String!
        $colorHex: String!
        $sortOrder: Int!
        $throwConfetti: Boolean
        $simpleEmailTemplateId: String
    ) {
        priorityStatuses {
            createPriorityStatus(
                input: {
                    name: $name
                    colorHex: $colorHex
                    sortOrder: $sortOrder
                    throwConfetti: $throwConfetti
                    simpleEmailTemplateId: $simpleEmailTemplateId
                }
            ) {
                priorityStatusId
                name
                colorHex
                sortOrder
                isMutable
                throwConfetti
                simpleEmailTemplateId
            }
        }
    }
`;
export const UpdatePriorityStatusMutation = gql `
    mutation UpdatePriorityStatus(
        $priorityStatusId: String!
        $name: String
        $colorHex: String
        $sortOrder: Int
        $throwConfetti: Boolean
        $simpleEmailTemplateId: String
    ) {
        priorityStatuses {
            updatePriorityStatus(
                input: {
                    priorityStatusId: $priorityStatusId
                    name: $name
                    colorHex: $colorHex
                    sortOrder: $sortOrder
                    throwConfetti: $throwConfetti
                    simpleEmailTemplateId: $simpleEmailTemplateId
                }
            ) {
                priorityStatusId
                name
                colorHex
                sortOrder
                isMutable
                throwConfetti
                simpleEmailTemplateId
            }
        }
    }
`;
export const BulkReorderPriorityStatusesMutation = gql `
    mutation BulkReorderPriorityStatuses($input: [BulkReorderInput!]!) {
        priorityStatuses {
            bulkReorderPriorityStatuses(input: $input) {
                priorityStatusId
                sortOrder
            }
        }
    }
`;
export const DeleteAndReplacePriorityStatusMutation = gql `
    mutation DeleteAndReplacePriorityStatus(
        $priorityStatusIdToDelete: String!
        $priorityStatusIdToReplaceWith: String!
    ) {
        priorityStatuses {
            deleteAndReplacePriorityStatus(
                priorityStatusIdToDelete: $priorityStatusIdToDelete
                priorityStatusIdToReplaceWith: $priorityStatusIdToReplaceWith
            ) {
                priorityStatusId
            }
        }
    }
`;
